/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { QuestionnaireStrictHttpResponse } from '../../questionnaire-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SaveQuestionnaireRequestModel } from '../../models/save-questionnaire-request-model';
import { SaveQuestionnaireResponseModel } from '../../models/save-questionnaire-response-model';

export interface ApiConsumerQuestionnaireSavePost$Params {
      body?: SaveQuestionnaireRequestModel
}

export function apiConsumerQuestionnaireSavePost(http: HttpClient, rootUrl: string, params?: ApiConsumerQuestionnaireSavePost$Params, context?: HttpContext): Observable<QuestionnaireStrictHttpResponse<SaveQuestionnaireResponseModel>> {
  const rb = new RequestBuilder(rootUrl, apiConsumerQuestionnaireSavePost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as QuestionnaireStrictHttpResponse<SaveQuestionnaireResponseModel>;
    })
  );
}

apiConsumerQuestionnaireSavePost.PATH = '/api/consumer/questionnaire/save';
